import emailjs from '@emailjs/browser';
import React, { useState, useRef, useEffect } from 'react';
import '../styles/Mail.css';
import { send } from 'emailjs-com';





const Mail = () => {
  const radio = useRef();
  const error = useRef(null);
  const [toSend, setToSend] = useState({
    subject: '',
    name: '',
    email: '',
    message: '',
  });
  const [isRestValid, setIsRestValid] = useState();
  const [isMessageSent, setIsMessageSent] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const valid = {
    email: false,
    rest: false,
  };

  <div ref={error} className='error-message'>
    <p>There was an error sending the email. Please try again later.</p>
  </div>


  const validation = (email, name, message, subject) => {
    const acceptedEmail = [
      'gmail.com',
      'yahoo.com',
      'yahoo.co.in',
      'outlook.com',
      'protonmail.com',
      'aol.com',
      'icloud.com',
      'me.com',
      'mac.com',
      'gmx.com',
      'hey.com',
    ];
    if (
      email.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      )
    ) {
      acceptedEmail.includes(email.split('@')[1])
        ? (valid.email = true)
        : (valid.email = false);
      console.log('email is valid')
      setIsEmailValid(true);
    } else {
      valid.email = false;
      console.log('email is not valid')
      setIsEmailValid(false);
    }

    if (name !== '' && subject !== '' && message.length > 5) {
      valid.rest = true;
      setIsRestValid(true);
      console.log('rest is valid')
    } else {
      valid.rest = false;
      setIsRestValid(false);
      console.log('rest is not valid')
    }
    return valid;
  };

  const reset = () => {
    setToSend({
      subject: '',
      name: '',
      email: '',
      message: '',
    });
    setIsDisabled(false);
  };


  const handleClick = () => {
    <div ref={error} className='error-message'>
      <p>There was an error sending the email. Please try again later.</p>
    </div>

    validation(toSend.email, toSend.name, toSend.message, toSend.subject);
    const condition = Object.values(valid).every((value) => value === true);
    if (condition === false) {
      console.log('something is missing')
    }
    else {
      setIsMessageSent(true);
      setIsPopupVisible(true);
      setTimeout(() => {
        setIsPopupVisible(false);
      }, 17000);
      send(
        "service_jybdk3x",
        "template_ywm4xma",
        {
          subject: toSend.subject,
          name: toSend.name,
          email: toSend.email,
          message: toSend.message,
        },
        "6Ha6IfMAo4yfcFTOh"
      )
        .then(() => {
          console.log('Email sent successfully!');
          reset();
        })
        .catch(() => {
          console.log('Email sending failed.');
          setIsMessageSent(false);
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setToSend((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  return (
    <div className='mail' id='mail'>
      <h2>Get In Touch</h2>
      {isRestValid === false && (

        <div className='error-message'>
          <p style={{ color: 'red' }}> • Check your Name <br></br>• Write a Longer Message "Have At Least 5 Words"<br></br>• Choose your Subject</p>
        </div>
      )}

      {isEmailValid === false && (
        <div className='error-message'>
          <p style={{ color: 'red' }}>• Check your Email</p>
        </div>
      )}
      <div>
        <div className='entry valid'>
          <div>
            <label htmlFor='name'>Name</label>
            <input
              type='text'
              name='name'
              autoComplete='off'
              value={toSend.name}
              onChange={handleChange}
            />
          </div>
          <div>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              name='email'
              autoComplete='off'
              value={toSend.email}
              onChange={handleChange}
            />
          </div>
          <div className='options'>
            <div>
              <input
                type='radio'
                name='subject'
                value='work'
                id='work'
                checked={toSend.subject === 'work'}
                onChange={handleChange}
                ref={radio}
                disabled={isDisabled}
              />
              <label htmlFor='work'>Work</label>
            </div>
            <div>
              <input
                type='radio'
                name='subject'
                value='collaboration'
                id='collaboration'
                checked={toSend.subject === 'collaboration'}
                onChange={handleChange}
                ref={radio}
                disabled={isDisabled}
              />
              <label htmlFor='collaboration'>Collaboration</label>
            </div>
            <div>
              <input
                type='radio'
                name='subject'
                value='other'
                id='other'
                checked={toSend.subject === 'other'}
                onChange={handleChange}
                ref={radio}
                disabled={isDisabled}
              />
              <label htmlFor='other'>Other</label>
            </div>
          </div>
          <div className='entry-message'>
            <label htmlFor='message'>Message</label>
            <textarea
              name='message'
              value={toSend.message}
              onChange={handleChange}
              rows='5'
              disabled={isDisabled}
            ></textarea>
          </div>
        </div>
        <button className='btn' onClick={handleClick} style={{ color: 'white' }} >
          {isMessageSent ? 'Message sent!' : 'Send Message'}
        </button>
        {isPopupVisible && (
          <div className="popup">
            <div className="popup-content">
              <div className="popup-message">
                <p align='centre'>🎉 Email sent! 🎉<br></br>I will get back to you as soon as possible. <br></br>Have A Nice Day ☕ </p>
                <button className='btn' onClick={() => setIsPopupVisible(false)}>Okie Dokie 👌</button>
              </div>
              <div className="popup-loading-bar"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Mail;
